
// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
const {
    SECOND_STEP,
    WIZARD_SECOND_STEP
} = require('constants/index');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

const requestAccessDataInProgress = () => ({
    type: actionTypes.CODE_OTP_DATA_REQUEST
});

const requestAccessKeyDataFailure = (error) => ({
    type: actionTypes.CODE_OTP_DATA_FAILURE,
    payload: {
        error
    }
});

const requestDataReset = () =>({
     type: actionTypes.CODE_OTP_DATA_RESET
});

const requestResetError = () =>({
     type: actionTypes.CODE_OTP_ERROR_RESET
});

const sendPhoneOTPSuccess = (data) =>({
    type: actionTypes.CODE_OTP_SUCCESS,
    payload: {
        info:  data
    }
});

const requestStepSuccess = (step) => ({
    type: actionTypes.USER_DATA_SET_STEP,
    payload: {
        step
    }
});


const sendPhoneOTP = () => (dispatch, getState) => {
    const isAlreadyFetching = getState().codeOtp.get('isFetching');
    const data = getState().userData.get('data');
    const phoneOTP = data.get('movil');
    const codigoOTP = data.get('persona').get('codigo');
    const TipoOTP = data.get('persona').get('tipo');

    if (!isAlreadyFetching) {
        const requestData = {
                query: {
                    "codigo": codigoOTP,
                    "movil": phoneOTP,
                    "tipo": TipoOTP
                }
        };
        dispatch(requestAccessDataInProgress());
        return APIPost(dispatch, apiURLBuilder.getURL('requestKeysSendOTPToken'), requestData)
            .then(response => {dispatch(sendPhoneOTPSuccess(response)); dispatch(requestStepSuccess(WIZARD_SECOND_STEP)); } )
            .catch(response => dispatch(requestAccessKeyDataFailure(response.error)));
    }
};



const sendPhoneOTPDisaster = () => (dispatch, getState) => {
    const isAlreadyFetching = getState().codeOtp.get('isFetching');
    const data = getState().userData.get('data');
    const phoneOTP = data.get('movil');
    const codigoOTP = data.get('persona').get('codigo');
    const TipoOTP = data.get('persona').get('tipo');
    const tokenCredential = getState().customerFinder.getIn(['steps', SECOND_STEP, 'token']);

    if (!isAlreadyFetching) {
        const params = {
            header: {
                openbankAuthToken: tokenCredential
            },
            query: {
                "codigo": codigoOTP,
                "movil": phoneOTP,
                "tipo": TipoOTP
            }
        };

        dispatch(requestAccessDataInProgress());
        return APIPost(dispatch, apiURLBuilder.getURL('requestKeysSendOTPToken'), params)
            .then(response =>{ dispatch(sendPhoneOTPSuccess(response));  dispatch(requestStepSuccess(WIZARD_SECOND_STEP)); })
            .catch(response => dispatch(requestAccessKeyDataFailure(response.error)));
    }
};


const CodeOTPDataReset = () => (dispatch) => {
    dispatch(requestDataReset());
};

const ResetError = () => (dispatch) => {
    dispatch(requestResetError());
};

module.exports = {
    sendPhoneOTP,
    CodeOTPDataReset,
    ResetError,
    sendPhoneOTPDisaster,
    requestStepSuccess
};
